import axios from './AxiosInstance';
import { getApiUrl } from '../utils/ApiUtils';

/**
 * ZettleService — API client for the Zettle integration
 * (Inställningar → Zettle). Backend routes live under /:companyId/zettle.
 *
 * The connect round-trip mirrors Bankanslutningar: POST /authorize returns a
 * consent URL, the browser does a FULL-PAGE redirect to Zettle, and the backend
 * 302s back to /:companyId/settings/zettle?zettle_connected=… once it has
 * exchanged the code. A popup would be nicer but breaks on mobile Safari and
 * behind strict popup blockers, which is why both existing OAuth flows here use
 * a full-page redirect.
 */

const base = (companyId) => `${companyId}/zettle`;

/** GET all Zettle connections for the company. */
export async function fetchConnections(companyId) {
    const { data } = await axios.get(getApiUrl(`${base(companyId)}/connections`), {
        withCredentials: true,
    });
    return Array.isArray(data) ? data : [];
}

/** GET one connection plus its per-status event counts. */
export async function fetchStatus(companyId, connectionId) {
    const { data } = await axios.get(
        getApiUrl(`${base(companyId)}/connections/${connectionId}/status`),
        { withCredentials: true }
    );
    return data;
}

/** GET the needs-review queue: everything the pipeline refused to auto-book. */
export async function fetchNeedsReview(companyId, connectionId, { limit = 50, offset = 0 } = {}) {
    const { data } = await axios.get(
        getApiUrl(`${base(companyId)}/connections/${connectionId}/review?limit=${limit}&offset=${offset}`),
        { withCredentials: true }
    );
    return data;
}

/** POST authorize — returns { authorizationUrl } for the full-page redirect. */
export async function startConnect(companyId) {
    const { data } = await axios.post(
        getApiUrl(`${base(companyId)}/connections/authorize`),
        {},
        { withCredentials: true }
    );
    return data;
}

/**
 * DELETE a connection. Stored purchases are KEPT — they are underlag for
 * verifikat already in the ledger and carry a 7-year retention duty, so this
 * stops the feed rather than erasing history.
 */
export async function disconnect(companyId, connectionId) {
    const { data } = await axios.delete(
        getApiUrl(`${base(companyId)}/connections/${connectionId}`),
        { withCredentials: true }
    );
    return data;
}
